import { api } from './client';

/**
 * Resumen del día para el dashboard del negocio. Prefijo: /api/dashboard
 * (ADMIN). Tipos espejo de apps/api/src/services/dashboard.service.ts.
 */

export interface TrabajosHoy {
  total: number;
  asignados: number;
  enSitio: number;
  completados: number;
  noCompletados: number;
}

export interface QuejaReciente {
  jobId: string;
  conversationId: string | null;
  cliente: string;
  respuesta: string;
  fecha: string;
}

export interface DashboardResumen {
  calientesSinAtender: number;
  trabajosHoy: TrabajosHoy;
  quejas: QuejaReciente[];
}

export const getDashboardResumen = () => api.get<DashboardResumen>('/api/dashboard/resumen');
